const UPGRADE_MODAL_TYPES = {
	UPGRADE_PLAN: 'upgradePlan',
	INCREASE_RESPONSES: 'increaseResponses',
};

export default UPGRADE_MODAL_TYPES;
